import { useMutation } from '@tanstack/react-query';

import { verifyCode, verifyEmail } from '@/apis/auth';

type VerifyEmailMethod = 'register' | 'reset';

export class EmailVerifyError extends Error {
  status: number;
  constructor(status: number, statusText: string) {
    super(statusText);
    this.status = status;
  }
}

export const useVerifyEmail = (method: VerifyEmailMethod = 'register') => {
  return useMutation({
    mutationFn: async (email: string) => {
      const res = await verifyEmail(email, method);
      if (!res.ok) {
        throw new EmailVerifyError(res.status, res.statusText);
      }
      return res;
    },
  });
};

export const useVerifyCode = () => {
  return useMutation({
    mutationFn: async ({ email, code }: { email: string; code: string }) => {
      const res = await verifyCode(email, code);
      if (!res.ok) {
        throw new EmailVerifyError(res.status, res.statusText);
      }
      return res;
    },
  });
};
